import axiosConfig from './axiosConfig';

/**
 * Mobilist API (pih-server, mounted at /pih):
 *   POST   /mobilists       create
 *   GET    /mobilists       list (all users, soft-deleted excluded)
 *   GET    /mobilists/:id   view one
 *   PUT    /mobilists/:id   edit
 *   DELETE /mobilists/:id   soft delete
 * The Excel file is still generated in the frontend for now; the
 * backend only stores the mobilist data (excelS3Key stays null).
 */

const unwrap = (res) => res?.data?.data;

const toItemArray = (items) => {
  if (!items) return [];
  if (Array.isArray(items)) return items;
  return Array.from(items); // Set
};

// Convert the detail-view state (Sets) into JSON-safe arrays.
export const toMobilistPayload = (data) => {
  const shared = {};
  const selections = data.selections || {};
  const walk = (categories) => {
    for (const [catId, groups] of Object.entries(categories || {})) {
      for (const [groupName, items] of Object.entries(groups || {})) {
        shared[catId] = shared[catId] || {};
        shared[catId][groupName] = [...new Set([...(shared[catId][groupName] || []), ...toItemArray(items)])];
      }
    }
  };
  if (selections.shared || selections.lines) {
    walk(selections.shared);
    Object.values(selections.lines || {}).forEach(walk);
  } else {
    Object.values(selections).forEach(walk);
  }

  return {
    projectName: data.projectName,
    projectNumber: data.projectNumber,
    wbsElement: data.wbsElement,
    projectType: data.projectType,
    shifts: data.shifts,
    productionDays: data.productionDays,
    numberOfStations: data.numberOfStations,
    totalPersonnel: data.totalPersonnel,
    numberOfPipelines: data.numberOfPipelines,
    createdBy: data.createdBy,
    totalCost: data.totalCost || 0,
    excelS3Key: data.excelS3Key || null,
    excelFileName: data.excelFileName || null,
    pipelines: (data.pipelines || []).map((p) => ({
      pipeSize: p.pipeSize,
      wallThickness: p.wallThickness,
      numberOfFieldJoints: p.numberOfFieldJoints,
      factoryCoatingType: p.factoryCoatingType,
      fjcType: p.fjcType,
      steelCutbacks: Array.isArray(p.steelCutbacks) ? p.steelCutbacks : [],
      steelCutbacksText: p.steelCutbacksText || '',
      infillType: p.infillType,
      infillCutbacks: p.infillCutbacks,
      infillThickness: p.infillThickness,
    })),
    selections: { shared },
    backupSelections: toItemArray(data.backupSelections),
  };
};

export const listMobilists = async () => unwrap(await axiosConfig.get('/mobilists')) || [];

export const getMobilist = async (id) => unwrap(await axiosConfig.get(`/mobilists/${id}`));

export const createMobilist = async (data) =>
  unwrap(await axiosConfig.post('/mobilists', toMobilistPayload(data)));

export const updateMobilist = async (id, data) =>
  unwrap(await axiosConfig.put(`/mobilists/${id}`, toMobilistPayload(data)));

export const deleteMobilist = async (id) => unwrap(await axiosConfig.delete(`/mobilists/${id}`));
